// @mui
import {
    Stack,
    Drawer,
    Divider,
    Typography,
    Alert,
    Box,
    Tabs,
    Tab,
    MenuItem,
    TableContainer,
    Table,
    TableCell,
    TableRow,
    TableHead,
    TableBody,
    DialogContentText,
    Paper,
    Tooltip,
    Button,
} from '@mui/material';
import Iconify from '../iconify/Iconify';
import Scrollbar from '../scrollbar/Scrollbar';
import { useTranslation } from 'react-i18next';
import { FormatNumber, eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import { useTheme } from '@mui/material/styles';
import { TabContext, TabPanel } from '@mui/lab';
import Loader from '../loader/loader';
import { toast } from 'react-toastify';
import moment from 'moment';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useEffect, useRef, useState } from 'react';
import ButtonAction from '../Button.js/SaveButton';
import Label from '../label';
import crypt from 'src/utils/service/crypt';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import GiveDeviceModal from 'src/component-project/GiveDeviceModal';
import DetailDevice from 'src/component-project/QRCodePages/DetailDevice';
import TableQuantityActionDevie from 'src/component-project/QRCodePages/TableQuantityActionDevice';
import ListActionDevice from 'src/component-project/QRCodePages/ListActionDevice';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function QRCodeDeviceModal({
    visible = false,
    setVisible,
    dataSearch,
    setDataSearch,
    isImportWarehouse = false,
}) {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [value, setValue] = useState('device');
    const fullWidth = true;
    const maxWidth = 'md';
    const [dataDevice, setDataDevice] = useState(null);
    const [dataQuantity, setDataQuantity] = useState(null);

    const [tableData, setTableData] = useState([]);
    const getRefGiveDevice = useRef(false);
    const [getFlagsGiveDevice, setGetFlagsGiveDevice] = useState(false);

    const getRef = useRef(false);
    const [getFlags, setGetFlags] = useState(false);
    // const warningImportExport = useRef(false);
    const [warningImportExport, setWarningImportExport] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataAction, setDataAction] = useState({});
    const tableRef = useRef(null);
    const [openSibarDevice, setopenSibarDevice] = useState(false);

    const menu = sessionStorage.getItem('menu');
    let idImportWareHouse = {};
    let permissionListTake = {};
    let permissionListBorrow = {};
    let permissionGiveBack = {};

    const dataActionRef = useRef(null);

    if (menu) {
        try {
            const data = JSON.parse(crypt.deCode(menu));
            // console.log('Loading menu', data[0]);
            idImportWareHouse = data[0].filter((item) => item.screens_key === 'nhap_xuat_tb')[0];
            permissionListTake = data[0].filter((item) => item.screens_key === 'ds_lay_tb')[0];
            permissionListBorrow = data[0].filter((item) => item.screens_key === 'ds_muon_tb')[0];
            permissionGiveBack = data[0].filter((item) => item.screens_key === 'tra_thiet_bi')[0];
        } catch (error) {}
    }

    useEffect(() => {
        if (visible) {
            getRefGiveDevice.current = false;
            setDataDevice(dataSearch.o_1);
            setDataQuantity(dataSearch.o_2);
            setTimeout(() => {
                getDataGiveDevice();
            }, 1000);
        }
    }, [visible]);

    useEffect(() => {
        if (visible || openSibarDevice) {
            setTimeout(() => {
                getDataGiveDevice();
            }, 1000);
        }
    }, [visible, openSibarDevice]);

    const getData = (valueDeviceCode, valueCabinetCode) => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [valueDeviceCode, valueCabinetCode];
        sendRequest(serviceList.getByDeviceCode, InVal, getDataResult, true, timeOutFunct, 40000);
    };

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataDevice(message.proc_data.rows[0].o_1);
            setDataQuantity(message.proc_data.rows[0].o_2);
            setLoading(true);
            setTimeout(() => setLoading(false), 1000);
            // setVisibleQRCodeModal(true);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        // closeCell();
        setGetFlags(false);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getDataGiveDevice = () => {
        if (getRefGiveDevice.current) {
            return;
        }
        getRefGiveDevice.current = true;
        setGetFlagsGiveDevice(true);
        const Inval = [dataSearch.o_1.device_cd];
        sendRequest(
            serviceList.getGiveTransactionByDevice,
            Inval,
            getDataResultGiveDevice,
            true,
            timeOutFunctGiveDevice,
            40000
        );
    };

    const getDataResultGiveDevice = (reqInfoMap, message) => {
        // console.log("==================getDataResultGiveDevice==============================")
        getRefGiveDevice.current = false;
        setGetFlagsGiveDevice(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            let data = message.proc_data.rows[0].o_1;
            // data = data.filter((item) => (item.qty_tra = item.qty));
            setTableData(data.filter((item) => (item.qty_tra = item.qty)));
        }
    };

    const timeOutFunctGiveDevice = (reqInfo) => {
        getRefGiveDevice.current = false;
        setGetFlagsGiveDevice(false);
        toast.error(t('error.time_out'));
    };

    // console.log("giveDevice", tableData)

    const TABLE_HEAD_DEVICE_CD = [
        { id: 'company', label: t('info'), alignRight: false },
        { id: 'quantity_give', label: t('quantity_give'), alignRight: false },
        { id: 'note', label: t('note_'), alignRight: false },
        { id: 'quantity_give', label: t('day_need_give'), alignRight: false },
        { id: 'quantity_borrow', label: t('quantity_borrow'), alignRight: false },
        { id: 'Thao tác', label: '', alignRight: false },
        { id: '1', label: '', alignRight: false },
    ];

    const addQuantity = (data, index, key, maxnumber = 1) => {
        if (key) {
            if (index >= 0 && data.qty_tra < data.qty) {
                const arr = [...tableData];
                arr[index].qty_tra = arr[index].qty_tra + 1;
                setTableData(arr);
            }
        } else {
            if (data.qty_tra > 1) {
                const arr = [...tableData];
                arr[index].qty_tra = arr[index].qty_tra - 1;
                setTableData(arr);
            }
        }
    };

    if (dataDevice?.length === 0) {
        return (
            <>
                <BootstrapDialog
                    fullWidth={fullWidth}
                    maxWidth={maxWidth}
                    fullScreen={fullScreen}
                    open={visible}
                    onClose={() => setVisible(!visible)}
                    aria-labelledby="customized-dialog-title"
                >
                    <BootstrapDialogTitle id="scroll-dialog-title" onClose={() => setVisible(!visible)}>
                        <Typography variant="subtitle1" sx={{ ml: 1 }}>
                            {t('info') + ' ' + t('device').toLocaleLowerCase()}
                        </Typography>
                    </BootstrapDialogTitle>
                    <DialogContent dividers>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            Không tìm thấy thiết bị
                        </Typography>
                    </DialogContent>
                    <DialogActions></DialogActions>
                </BootstrapDialog>
            </>
        );
    }

    return (
        <>
            <BootstrapDialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                fullScreen={fullScreen}
                open={visible}
                onClose={() => {
                    setValue('device');
                    setTableData([]);
                    setVisible(!visible);
                }}
                aria-labelledby="customized-dialog-title"
            >
                <BootstrapDialogTitle
                    id="scroll-dialog-title"
                    onClose={() => {
                        setValue('device');
                        setTableData([]);
                        setVisible(!visible);
                    }}
                >
                    <Loader Loading={getFlagsGiveDevice || loading} />
                    <Stack display={'flex'} flexDirection={'row'} flexWrap={'wrap'} gap={2} justifyContent={'start'}>
                        <Typography variant="subtitle1" sx={{ ml: 1 }}>
                            {t('info') + ' ' + t('device').toLocaleLowerCase()}
                        </Typography>
                        {dataDevice?.total_quantity <= 0 || warningImportExport === true ? (
                            <Label variant="filled" color={'warning'} sx={{}}>
                                <Iconify icon="material-symbols:warning-outline-rounded" /> {t('warning')}
                            </Label>
                        ) : (
                            ''
                        )}
                        {''}
                        {dataDevice?.check_inv_status === '0' ? (
                            <Label variant="filled" color={'error'}>
                                {t('system_statistical')}
                            </Label>
                        ) : (
                            ''
                        )}{' '}
                    </Stack>
                </BootstrapDialogTitle>
                <DialogContent>
                    <>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box
                                    sx={{
                                        borderColor: 'divider',
                                        position: 'static',
                                        // width: fullScreen ? '80%' : '58%',
                                        // overflowX: 'hidden',
                                        backgroundColor: '#fff',
                                    }}
                                >
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        sx={{ backgroundColor: '#fff', width: '100%' }}
                                        textColor="primary"
                                        variant="fullWidth"
                                        aria-label="basic tabs example"
                                    >
                                        <Tab label={t('device')} value={'device'} sx={{ backgroundColor: '#fff' }} />
                                        <Tab
                                            label={t('property')}
                                            value={'property'}
                                            sx={{ backgroundColor: '#fff' }}
                                        />
                                        <Tab
                                            label={t('device_detail')}
                                            value={'device_detail'}
                                            sx={{ backgroundColor: '#fff' }}
                                        />
                                        {!isImportWarehouse && (
                                            <Tab
                                                label={
                                                    dataDevice?.status_action === '1' ? t('ds_lay_tb') : t('ds_muon_tb')
                                                }
                                                value={'list_device'}
                                                sx={{ backgroundColor: '#fff' }}
                                            />
                                        )}
                                    </Tabs>
                                </Box>
                                <Stack paddingTop={0}>
                                    <TabPanel value={'device'} dir={theme.direction}>
                                        <Stack spacing={0} sx={{ p: 0 }}>
                                            <Stack direction="column" sx={{ px: 0, py: 0 }}>
                                                <Stack spacing={0.5} sx={{ pl: 1.5, pt: 0 }}>
                                                    <DetailDevice dataDevice={dataDevice} type={'base'} />
                                                    <TableQuantityActionDevie
                                                        dataDevice={dataDevice}
                                                        setDataDevice={setDataDevice}
                                                        dataQuantity={dataQuantity}
                                                        setDataQuantity={dataQuantity}
                                                        idImportWareHouse={idImportWareHouse}
                                                        visibleQRCodeModal={visible}
                                                        setVisibleQRCodeModal={setVisible}
                                                        fuctGet={getData}
                                                        warningImportExport={warningImportExport}
                                                        setWarningImportExport={setWarningImportExport}
                                                        isImportWarehouse={isImportWarehouse}
                                                    />

                                                    {!isImportWarehouse &&
                                                        permissionGiveBack?.search_permission === '1' && (
                                                            <Stack>
                                                                {tableData.length === 0 ? (
                                                                    <></>
                                                                ) : (
                                                                    <>
                                                                        <GiveDeviceModal
                                                                            open={openSibarDevice}
                                                                            onClose={() => setopenSibarDevice(false)}
                                                                            onOpen={() => setopenSibarDevice(true)}
                                                                            setOpen={setopenSibarDevice}
                                                                            device={dataAction}
                                                                            isGivedevice
                                                                            getData={getData}
                                                                            // fuctGet={getData}
                                                                        />
                                                                        <Stack>
                                                                            <Typography
                                                                                variant="subtitle1"
                                                                                sx={{ color: 'text.secondary' }}
                                                                            >
                                                                                {t('give_device')}
                                                                            </Typography>
                                                                        </Stack>
                                                                        <TableContainer sx={{}}>
                                                                            <Table ref={tableRef}>
                                                                                <DepartmentListHead
                                                                                    order={'asc'}
                                                                                    orderBy={'name'}
                                                                                    headLabel={TABLE_HEAD_DEVICE_CD}
                                                                                    rowCount={tableData.length}
                                                                                    // numSelected={selected.length}
                                                                                />
                                                                                <TableBody>
                                                                                    {tableData.length > 0 &&
                                                                                        tableData.map((item, index) => {
                                                                                            return (
                                                                                                <TableRow
                                                                                                    hover
                                                                                                    key={index}
                                                                                                    tabIndex={-1}
                                                                                                    role="checkbox"
                                                                                                >
                                                                                                    <TableCell padding="checkbox"></TableCell>
                                                                                                    <TableCell
                                                                                                        align="left"
                                                                                                        style={{
                                                                                                            maxWidth:
                                                                                                                '100%',
                                                                                                            minWidth:
                                                                                                                '50px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <Stack
                                                                                                            display={
                                                                                                                'flex'
                                                                                                            }
                                                                                                            flexDirection={
                                                                                                                'column'
                                                                                                            }
                                                                                                        >
                                                                                                            <Typography
                                                                                                                variant="subtitle3"
                                                                                                                noWrap
                                                                                                                sx={{
                                                                                                                    fontWeight:
                                                                                                                        '600',
                                                                                                                }}
                                                                                                            >
                                                                                                                {t(
                                                                                                                    'cabinet'
                                                                                                                )}
                                                                                                                :{' '}
                                                                                                                {
                                                                                                                    item.cabinet_nm
                                                                                                                }
                                                                                                            </Typography>
                                                                                                            <Typography
                                                                                                                variant="subtitle3"
                                                                                                                noWrap
                                                                                                            >
                                                                                                                {t(
                                                                                                                    'drawer'
                                                                                                                )}
                                                                                                                :{' '}
                                                                                                                {
                                                                                                                    item.drawer_nm
                                                                                                                }
                                                                                                            </Typography>{' '}
                                                                                                            {item?.cabinet_type ===
                                                                                                            'square' ? (
                                                                                                                <Typography
                                                                                                                    variant="subtitle3"
                                                                                                                    noWrap
                                                                                                                >
                                                                                                                    {t(
                                                                                                                        'cell'
                                                                                                                    )}
                                                                                                                    :{' '}
                                                                                                                    {`[ ${item?.cell_lc?.row} : ${item?.cell_lc?.column} ]`}
                                                                                                                </Typography>
                                                                                                            ) : (
                                                                                                                <Typography
                                                                                                                    variant="subtitle3"
                                                                                                                    noWrap
                                                                                                                >
                                                                                                                    {t(
                                                                                                                        'ordinal_number'
                                                                                                                    )}
                                                                                                                    :{' '}
                                                                                                                    {`[${item?.cell_lc?.column}]`}
                                                                                                                </Typography>
                                                                                                            )}
                                                                                                        </Stack>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={{
                                                                                                            textAlign:
                                                                                                                'center',
                                                                                                            maxWidth:
                                                                                                                '100%',
                                                                                                            minWidth:
                                                                                                                '135px',
                                                                                                        }}
                                                                                                    >
                                                                                                        {item?.qty}
                                                                                                    </TableCell>{' '}
                                                                                                    <TableCell
                                                                                                        style={{
                                                                                                            textAlign:
                                                                                                                'left',
                                                                                                            maxWidth:
                                                                                                                '100%',
                                                                                                            minWidth:
                                                                                                                '100px',
                                                                                                        }}
                                                                                                    >
                                                                                                        {item?.note}
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={{
                                                                                                            textAlign:
                                                                                                                'left',
                                                                                                            width: '100%',
                                                                                                        }}
                                                                                                    >
                                                                                                        <Label
                                                                                                            color={
                                                                                                                (moment(
                                                                                                                    item.expiry_date,
                                                                                                                    'YYYYMMDD'
                                                                                                                ).diff(
                                                                                                                    moment(),
                                                                                                                    'days'
                                                                                                                ) <=
                                                                                                                    2 &&
                                                                                                                    'error') ||
                                                                                                                'primary'
                                                                                                            }
                                                                                                        >
                                                                                                            {moment(
                                                                                                                item?.return_date,
                                                                                                                'YYYYMMDD'
                                                                                                            ).format(
                                                                                                                'DD/MM/YYYY'
                                                                                                            )}{' '}
                                                                                                        </Label>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={{
                                                                                                            textAlign:
                                                                                                                'left',
                                                                                                            width: '100%',
                                                                                                            minWidth:
                                                                                                                '120px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <Stack
                                                                                                            display={
                                                                                                                'flex'
                                                                                                            }
                                                                                                            flexDirection={
                                                                                                                'row'
                                                                                                            }
                                                                                                            gap={0.5}
                                                                                                            border={
                                                                                                                '1px solid #999'
                                                                                                            }
                                                                                                            borderRadius={
                                                                                                                '3px'
                                                                                                            }
                                                                                                            justifyContent={
                                                                                                                'center'
                                                                                                            }
                                                                                                            alignItems={
                                                                                                                'center'
                                                                                                            }
                                                                                                        >
                                                                                                            <IconButton
                                                                                                                color={
                                                                                                                    'primary'
                                                                                                                }
                                                                                                                onClick={() =>
                                                                                                                    addQuantity(
                                                                                                                        item,
                                                                                                                        index
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                <Iconify
                                                                                                                    icon="material-symbols:check-indeterminate-small"
                                                                                                                    width={
                                                                                                                        16
                                                                                                                    }
                                                                                                                    height={
                                                                                                                        16
                                                                                                                    }
                                                                                                                />
                                                                                                            </IconButton>
                                                                                                            <Typography
                                                                                                                variant="subtitle3"
                                                                                                                noWrap
                                                                                                                sx={{
                                                                                                                    fontWeight:
                                                                                                                        '600',
                                                                                                                }}
                                                                                                            >
                                                                                                                {
                                                                                                                    item.qty_tra
                                                                                                                }
                                                                                                            </Typography>
                                                                                                            <IconButton
                                                                                                                color={
                                                                                                                    'primary'
                                                                                                                }
                                                                                                                onClick={() =>
                                                                                                                    addQuantity(
                                                                                                                        item,
                                                                                                                        index,
                                                                                                                        1,
                                                                                                                        item.qty
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                <Iconify
                                                                                                                    icon="material-symbols:add"
                                                                                                                    width={
                                                                                                                        16
                                                                                                                    }
                                                                                                                    height={
                                                                                                                        16
                                                                                                                    }
                                                                                                                />
                                                                                                            </IconButton>
                                                                                                        </Stack>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        align="right"
                                                                                                        style={{
                                                                                                            textAlign:
                                                                                                                'center',
                                                                                                            maxWidth:
                                                                                                                '120px',
                                                                                                        }}
                                                                                                    >
                                                                                                        <Stack
                                                                                                            sx={{
                                                                                                                gap: 1,
                                                                                                            }}
                                                                                                        >
                                                                                                            <ButtonAction
                                                                                                                type="confirm"
                                                                                                                title={t(
                                                                                                                    'give'
                                                                                                                )}
                                                                                                                onClick={() => {
                                                                                                                    dataActionRef.current =
                                                                                                                        item;
                                                                                                                    // setVisibleQRCode(false);
                                                                                                                    setDataAction(
                                                                                                                        item
                                                                                                                    );
                                                                                                                    setopenSibarDevice(
                                                                                                                        true
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </Stack>
                                                                                                    </TableCell>
                                                                                                    <TableCell padding="checkbox"></TableCell>
                                                                                                </TableRow>
                                                                                            );
                                                                                            // }
                                                                                        })}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </>
                                                                )}
                                                            </Stack>
                                                        )}
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </TabPanel>
                                    <TabPanel value={'property'} dir={theme.direction}>
                                        <DetailDevice dataDevice={dataDevice} type={'property'} />
                                    </TabPanel>
                                    <TabPanel value={'device_detail'} dir={theme.direction}>
                                        <DetailDevice dataDevice={dataDevice} />
                                    </TabPanel>
                                    <TabPanel value={'list_device'} dir={theme.direction}>
                                        {dataDevice?.status_action === '1' ? (
                                            <ListActionDevice
                                                typeAction={'take'}
                                                dataDevice={dataDevice}
                                                permission={permissionListTake}
                                            />
                                        ) : (
                                            <ListActionDevice
                                                typeAction={'borrow'}
                                                dataDevice={dataDevice}
                                                permission={permissionListBorrow}
                                            />
                                        )}
                                    </TabPanel>
                                </Stack>
                            </TabContext>
                        </Box>
                    </>
                </DialogContent>
            </BootstrapDialog>
        </>
    );
}
